const a = (a2, e = "name") => a2 ? a2.map(/* @__PURE__ */ ((a3) => (e2) => ({ id: e2.id, value: String(e2[a3]) }))(e)) : [];
export {
  a as extractFormData
};
//# sourceMappingURL=extractFormData.js.map
